import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { deleteJob, listeJobs } from '../../actions/jobsAxctions'
import LIstJobsView from '../../containers/Jobs/ListJobs/LIstJobsView'

const LitsJobs = () => {
    const dispatch = useDispatch()
    const {jobs} = useSelector(state=>state.adminJobReducers)
    useEffect(() => {
      dispatch(listeJobs())
    
      return () => {
        
      }
    }, [])
    const deleteJobFn = (id,close)=>{
      dispatch(deleteJob(id,close))
    }
  return (
    <LIstJobsView jobs={jobs} deleteJob={deleteJobFn}/>
  )
}

export default LitsJobs